var _stop, _stop2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgFavoritesSelected(props) {
  const _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.172 1.842c.304-.911 1.593-.911 1.897 0l1.628 4.878a1 1 0 00.948.683h5.21c.975 0 1.373 1.253.577 1.817l-4.168 2.948a1 1 0 00-.371 1.133l1.603 4.803c.306.916-.737 1.69-1.526 1.133l-4.272-3.022a1 1 0 00-1.155 0L6.27 19.237c-.79.558-1.832-.216-1.526-1.133L6.347 13.3a1 1 0 00-.37-1.133L1.807 9.22c-.796-.564-.398-1.817.578-1.817h5.21a1 1 0 00.948-.683l1.628-4.878z",
    stroke: "url(#".concat(_id, ")"),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: 22.889,
    y1: 20.794,
    x2: 22.889,
    y2: -1,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#664FF9"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1253FA"
  })))));
}
export default SvgFavoritesSelected;